import { Reducer } from 'redux';
import {
  SearchState,
  SearchActionTypes,
  GLOBAL_SEARCH_INPROGRESS,
  GLOBAL_SEARCH_SUCCESS,
  GLOBAL_SEARCH_FAILURE,
} from './types';
import * as Bixby from '$/core';

const initialState: SearchState = {
  isGlobalSearching: true,
  error: undefined,
  globalResults: undefined,
};

const searchReducer: Reducer<SearchState> = (state = initialState, action: SearchActionTypes): SearchState => {
  switch (action.type) {
    case GLOBAL_SEARCH_INPROGRESS:
      return {
        ...state,
        isGlobalSearching: true,
        globalResults: undefined,
      };
    case GLOBAL_SEARCH_SUCCESS:
      return {
        ...state,
        isGlobalSearching: false,
        globalResults: action.payload,
      };
    case GLOBAL_SEARCH_FAILURE:
      return {
        ...state,
        isGlobalSearching: false,
        globalResults: undefined,
        error: action.payload as Bixby.Models.BixbyError,
      };
    default:
      return state;
  }
};
export default searchReducer;
